module.exports = __webpack_public_path__ + "img/product_112.56846ba.webp";